import { FC } from 'react'

import SpotifyIcon from 'src/Assets/Svg/spotify.svg?react'
import TikTokIcon from 'src/Assets/Svg/tiktok.svg?react'
import TikTokIconLight from 'src/Assets/Svg/tiktok_light.svg?react'
import { Roles } from 'src/Constants/enums'
import { AuthOutlineButton } from 'src/Components/Buttons/AuthOutlineButton'
import { useThemeMode } from 'src/Hooks/useThemeMode'

import {
  Card,
  Title,
  ButtonsColumn,
  Footer,
  FooterText,
  FooterLinkButton,
} from './styles'

const ICON_SIZE = 16

export type RoleSelectVariant = 'login' | 'signup'

export interface RoleSelectProps {
  variant: RoleSelectVariant
  onSelectRole: (role: Roles) => void
  onFooterAction: () => void
  className?: string
}

const COPY: Record<
  RoleSelectVariant,
  {
    title: string
    artistLabel: string
    curatorLabel: string
    creatorLabel: string
    footerText: string
    footerActionLabel: string
  }
> = {
  login: {
    title: 'Welcome back',
    artistLabel: 'Log in as Artist',
    curatorLabel: 'Log in as Playlist Curator',
    creatorLabel: 'Log in as TikTok Creator',
    footerText: `Don't have an account?`,
    footerActionLabel: 'Sign up',
  },
  signup: {
    title: 'Join to SoundCampaign',
    artistLabel: 'Join as Artist',
    curatorLabel: 'Join as Playlist Curator',
    creatorLabel: 'Join as TikTok Creator',
    footerText: 'I already have an account.',
    footerActionLabel: 'Log in',
  },
}

export const RoleSelect: FC<RoleSelectProps> = ({
  variant,
  onSelectRole,
  onFooterAction,
  className,
}) => {
  const copy = COPY[variant]
  const { resolvedTheme } = useThemeMode()
  const TikTok = resolvedTheme === 'dark' ? TikTokIconLight : TikTokIcon

  return (
    <Card className={className}>
      <Title>{copy.title}</Title>
      <ButtonsColumn>
        <AuthOutlineButton
          label={copy.artistLabel}
          onClick={() => onSelectRole(Roles.artist)}
        />
        <AuthOutlineButton
          icon={<SpotifyIcon width={ICON_SIZE} height={ICON_SIZE} />}
          label={copy.curatorLabel}
          onClick={() => onSelectRole(Roles.curator)}
        />
        <AuthOutlineButton
          icon={<TikTok width={ICON_SIZE} height={ICON_SIZE} />}
          label={copy.creatorLabel}
          onClick={() => onSelectRole(Roles.influencer)}
        />
      </ButtonsColumn>
      <Footer>
        <FooterText>{copy.footerText}</FooterText>
        <FooterLinkButton type='button' onClick={onFooterAction}>
          {copy.footerActionLabel}
        </FooterLinkButton>
      </Footer>
    </Card>
  )
}
